import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import { useUploadClientInsurance } from 'api/clients/use-upload-client-insurance';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import type { IInsuranceFormValues } from 'components/clients/client-insurance/components/client-insurance-modal';
import { ClientInsuranceModalWithButton } from 'components/clients/client-insurance/components/client-insurance-modal-with-button';
import type { IUploadClientInsuranceProps } from './types';

const UploadClientInsuranceComponent = (props: IUploadClientInsuranceProps) => {
  const { buttonLabel, buttonProps, clientId } = props;
  const { t } = useTranslation('client');
  const { mutateAsync: uploadInsurance, isLoading: isUploading } = useUploadClientInsurance();

  const handleUpload = async ({ file, validityPeriod }: IInsuranceFormValues) => {
    if (!file) return;

    await uploadInsurance({
      clientId,
      file,
      validFrom: validityPeriod[0].format('YYYY-MM-DD'),
      validTo: validityPeriod[1].format('YYYY-MM-DD'),
    });
  };

  return (
    <ClientInsuranceModalWithButton
      buttonLabel={buttonLabel || t('insurance_upload')}
      buttonProps={{ block: true, icon: <UploadOutlined />, type: 'primary', ...buttonProps }}
      title={t('insurance_upload_new')}
      submitText={t('insurance_save')}
      isSubmitting={isUploading}
      onSubmit={handleUpload}
    />
  );
};

export const UploadClientInsurance = withRoleGuard<IUploadClientInsuranceProps>(UploadClientInsuranceComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
]);
